import * as firebase from 'firebase';
import $ from 'jquery';
import DataStore from './DataStore'
import attributeIds from './attributeIds'
import GeoFire from "geofire";

import ReportsGenerator from './ReportsGenerator';

const ZonedDateTime = require('js-joda').ZonedDateTime;
const GOOGLE_GEOCODING_URL = "https://maps.googleapis.com/maps/api/geocode/json?sensor=false&key=AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw"
var WP_HOST = "infusioncenter.org";

class Api {
    constructor() {
        this.firebase = firebase;
        this.dataStore = new DataStore();
        this.firebaseApp = this.firebase.initializeApp(this.getFirebaseConfig());
        var firebaseGeoFireRef = this.firebase.database().ref("geoFire");
        this.geoFire = new GeoFire(firebaseGeoFireRef);

    }

    auth(success, error) {
        success = success || function () {};
        this.getWordPressUser(success, error);
    }

    getWordPressUser(success, error) {
        $($.ajax({
            url: "https://" + WP_HOST + "/locator-token/" + (this.isDev() ? "?dev=true" : ""),
            contentType: "application/json",
            success: success,
            error: error,
            crossDomain: true,
            xhrFields: {
                withCredentials: true
            }
        }));

    }

    firebaseAuth(token, error) {
        if (token) {
            firebase.auth().signInWithCustomToken(token).catch(error).then((data) => {});
        }
    }

    saveLocation(location) {
        if (location.key) {
            this.firebase.database().ref("locations/" + location.key).set(location);
            if (location.active) {
                this.geoFire.set(location.key, [location.latitude, location.longitude]);
            } else {
                this.geoFire.remove(location.key);
            }
        } else {
            var newEntry = this.firebase.database().ref("locations").push()
            newEntry.set(location);
            return newEntry.key;
        }
    }

    deleteLocation(location) {
        if (location.key) {
            this.firebase.database().ref("locations/" + location.key).remove();
            this.geoFire.remove(location.key)
        }
    }

    updateLocationsLocationDawg(location) {
        this.geoFire.set(location.key, [location.latitude, location.longitude]);
    }

    locationByKey(key, success) {
        var ref = this.firebase.database().ref("locations/" + key);
        ref.once('value', function (snapshot) {
            success({ ...snapshot.val(),
                key: key
            });
        });
    }

    locationByKeyPromise(key) {
        var ref = this.firebase.database().ref("locations/" + key);
        return ref.once('value');
    }

    locationsForOrgId(orgId, success) {
        var ref = this.firebase.database().ref("locations");
        ref.orderByChild("orgId").startAt(orgId).endAt(orgId).once('value', function (snapshot) {
            var results = [];
            snapshot.forEach(function (childSnapshot) {
                var value = childSnapshot.val();
                value.key = childSnapshot.key;
                results.push(value);
            });
            success(results)

        });
    }

    getAllLocations(success) {
        var ref = this.firebase.database().ref("locations");
        ref.orderByChild('active').once("value", function (snapshot) {
            var results = [];
            snapshot.forEach((node) => {
                var val = node.val();
                val.key = node.key //KBM - Need this for attributes
                results.push(val);
            });
            success(results);
        });
    }

    getAttributes(success) {
        this.getAll("attributes", success);
    }

    getSurveyQuestions(success) {
        var ref = this.firebase.database().ref("surveyQuestions");
        ref.once("value", function (snapshot) {
            success(snapshot.val());
        });
    }

    getSponsors(success) {
        this.getAll("sponsors", success);
    }

    getMedicationsAvailable(success) {
        return this.attributeByKey(attributeIds.medicationsAvailable, success)
    }

    getPracticeSpecialty(success) {
        return this.attributeByKey(attributeIds.practiceSpecialty, success)
    }

    attributeByKey(key, success) {
        var ref = this.firebase.database().ref("attributes/" + key);
        ref.once("value", function (snapshot) {
            success(snapshot.val());
        });

    }

    getAll(path, success) {
        var ref = this.firebase.database().ref(path);
        ref.once("value", function (snapshot) {
            var results = [];
            snapshot.forEach((node) => {
                var val = node.val();
                val.key = node.key //KBM - Need this for attributes
                results.push(val);
            });
            success(results);
        });
    }

    //KBM - TODO: better error handling
    geoCodeQuery(query, success) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", GOOGLE_GEOCODING_URL + "&address=" + query, true);
        xhr.onload = () => {
            var data = JSON.parse(xhr.responseText);

            if (data.results.length) {
                var lat = data.results[0].geometry.location.lat;
                var lng = data.results[0].geometry.location.lng;
                success(lat, lng);
            } else {
                success();
            }
        }
        xhr.send();
    }

    radiusSearch(lat, lng, radius, success) {
        var geoQuery = this.geoFire.query({
            center: [
                lat, lng
            ],
            radius: radius
        });
        geoQuery.on("key_entered", success)
    }

    newGeoQuery(lat, lng, radius, onKeyEntered, onKeyExited) {
        var geoQuery = this.geoFire.query({
            center: [
                lat, lng
            ],
            radius: radius
        });
        geoQuery.on("key_entered", onKeyEntered);
        geoQuery.on("key_exited", onKeyExited);
        return geoQuery;
    }

    updateGeoQuery(query, lat, lng, radius) {
        if (query) {
            let criteria = {};
            if (lat && lng) {
                criteria.center = [lat, lng];
            }
            if (radius) {
                criteria.radius = radius;
            }
            query.updateCriteria(criteria);
        }
    }

    uploadFile(file, uid, success) {
        var parts = file.name.split(".");
        var extension = parts[parts.length - 1];

        var storageRef = this.firebase.storage().ref();
        var fileRef = storageRef.child(uid + "." + extension);

        fileRef.put(file).then(function (snapshot) {
            success(snapshot.downloadURL);
        });
    }

    deleteFile(downloadURL) {
        var parts = downloadURL.split("/");
        var fileName = parts[parts.length - 1];
        fileName = fileName.substring(0, fileName.indexOf("?"));

        var storageRef = this.firebase.storage().ref();
        var fileRef = storageRef.child(fileName);

        fileRef.delete().then(function () {
            // console.log("successfully deleted file");
        }).catch(function (error) {
            // console.log("error deleting file");
        });
    }

    createShareEmail(shareEmail) {
        /**
        fromName, toName, toEmail, message, locationId
         */
        var newEntry = this.firebase.database().ref("shareEmails").push();
        newEntry.set({ ...shareEmail,
            sent: false
        });

    }

    createContactEmail(contactEmail) {
        /*
          name, email, phone, subject, message, locationId
        */
        var newEntry = this.firebase.database().ref("contactEmails").push();

        newEntry.set({ ...contactEmail,
            sent: false
        });

        this.trackLocationClick(contactEmail.locationId, 'contact_emails');

    }

    createBulkUploadRecord() {
        var bulkUpload = {
            started: new Date().toString(),
            completed: false
        };
        var newEntry = this.firebase.database().ref("bulk_uploads").push();
        newEntry.set(bulkUpload);
        bulkUpload.key = newEntry.key;
        return bulkUpload;
    }

    updateBulkUpload(bulkUpload) {
        this.firebase.database().ref("bulk_uploads/" + bulkUpload.key).set(bulkUpload);
    }

    createBulkUploadLocation(location) {
        var newEntry = this.firebase.database().ref("locations").push();
        newEntry.set(location);
        this.geoFire.set(newEntry.key, [location.latitude, location.longitude]);
    }

    claimLocation(location, success, error) {
        /*
         userDisplayName, userEmail, orgId, locationName, locationId
        */
        var currentUser = this.dataStore.getUser();

        if (location.orgId) {
            return;
        }

        if (!currentUser.orgId) {
            return;
        }

        this.firebase.database().ref("locations/" + location.key).update({
            active: false,
            orgId: currentUser.orgId
        });

        this.geoFire.remove(location.key);

        this.firebase.database().ref("claimRequest").push({
            userDisplayName: currentUser.displayName,
            userEmail: currentUser.email,
            orgId: currentUser.orgId,
            locationName: location.name,
            locationId: location.key
        }).then(() => success()).catch(err => error());

        // newEntry.set(, (err) => {
        //     if (err !== null) {
        //         error();
        //     } else {
        //         success();
        //     }
        // });
    }

    getFirebaseConfig() {
        // console.log('domain:', document.domain);
        // console.log('isDev:', this.isDev());
        if (!this.isDev()) {
            return { // Prod
                apiKey: "AIzaSyC14vZJSWjdgO5f6MYfxmjycl6Uy4Lm_tY",
                authDomain: "infusion-center-locator.firebaseapp.com",
                databaseURL: "https://infusion-center-locator.firebaseio.com",
                storageBucket: "infusion-center-locator.appspot.com",
                messagingSenderId: "724794030805",
                projectId: 'infusion-center-locator'
            };
        }
        return { // Dev
            apiKey: "AIzaSyAhn5CBTFRXESQoxIG0OM4hokHGPgY3SHU",
            authDomain: "infusion-center-locator-dev.firebaseapp.com",
            databaseURL: "https://infusion-center-locator-dev.firebaseio.com",
            storageBucket: "infusion-center-locator-dev.appspot.com",
            projectId: 'infusion-center-locator-dev'
        };
    }

    isDev() {
        return document.domain !== 'locator.infusioncenter.org';
    }

    trackSearchQuery(query, radius, lat, lng, filter, specialties) {
        if (lat && lng) {
            const searchRef = this.firebase.database().ref('/reports/searches/queries').push();
            searchRef.set({query, radius, lat, lng}).then(() => {
                this.trackSearchFilter(searchRef.key, filter, specialties);
                this.lastSearch = searchRef.key;
            });
        }
    }

    trackSearchFilter(searchKey, filter, specialties) {
        if (filter && filter.specialty && filter.specialty.length) {
            if (!searchKey) {
                searchKey = this.lastSearch;
            }
            filter.specialty.forEach((specialtyIndex) => {
                const record = {};
                record[searchKey] = true;
                this.firebase.database().ref(`/reports/searches/filters/specialty/${specialties[specialtyIndex].key}`).update(record);
            })
        } else {
            console.log('no specialties to track')
        }
    }

    trackMedicationFilter(searchKey, filter, medicationsAvailable) {
        if (filter && filter.medicationsAvailable && filter.medicationsAvailable.length) {
            if (!searchKey) {
                searchKey = this.lastSearch;
            }
            filter.medicationsAvailable.forEach((medicationIndex) => {
                const record = {};
                record[searchKey] = true;
                this.firebase.database().ref(`/reports/searches/filters/medication/${medicationsAvailable[medicationIndex].key}`).update(record);
            })
        } else {
            console.log('no medications to track')
        }
    }

    trackLocationDetailView(key) {
        this.lastPageView = this.firebase.database().ref(`/reports/locations/${key}/visits`).push({date: new Date().toString()}).key;
    }

    trackLocationClick(key, type) {
        this.firebase.database().ref(`/reports/locations/${key}/${type}`).push({
            visit: this.lastPageView,
            date: new Date().toString()
        })
    }

    generateReports() {
        const generator = new ReportsGenerator(this.firebase);
        generator.generateReports();
    }

    getAdminResources() {
        return new Promise((resolve, reject) => {
            this.firebase.database().ref('/admin_resources').once('value').then(snapshot => {
                resolve(snapshot.val());
            }, err => {
                reject(err);
            });
        });
    }

    uploadAdminResource(file, resource, index) {
        return new Promise((resolve, reject) => {
            firebase.storage().ref().child(`${resource.path}${file.name}`).put(file).then(snapshot => {
                this.updateAdminResourceUrl(snapshot, index).then(update => {
                    resolve(update);
                }).catch(err => {
                    reject(err);
                })
            }).catch(err => {
                reject(err);
            });
        });
    }

    updateAdminResourceUrl(snapshot, index) {
        return snapshot.ref.getDownloadURL().then(url => {
            let update = {
                downloadUrl: url,
                lastUpdated: ZonedDateTime.now().withFixedOffsetZone().toString()
            };
            return firebase.database().ref(`admin_resources/${index}`).update(update).then(() => update);
        });
    }

    getMemberResources() {
        return new Promise((resolve, reject) => {
            this.firebase.database().ref('/member_resources').once('value').then(snapshot => {
                resolve(snapshot.val());
            }, err => {
                reject(err);
            });
        });
    }

    // savePurchase(user, cart, charge) {
    //     return new Promise((resolve, reject) => {
    //         let purchase = {
    //             cart: cart,
    //             charge: charge,
    //             purchaseDate: ZonedDateTime.now().withFixedOffsetZone().toString(),
    //             purchasedBy: user.email
    //         };
    //         this.firebase.database().ref(`/purchase_history/${user.orgId}`).push(purchase).then(snapshot => {
    //             this.saveActivePurchases(user, cart, purchase, snapshot.key).then(activePurchase => {
    //                 resolve(activePurchase);
    //             }).catch(err => {
    //                 reject(err);
    //             });
    //             resolve(true);
    //         }, err => {
    //             reject(err);
    //         });
    //     });
    // }

    getActivePurchases(user) {
        return this.firebase.database().ref(`/active_purchases/${user.orgId}`).once('value');
    }

    watchActivePurchases(user, callback) {
        return this.firebase.database().ref(`/active_purchases/${user.orgId}`).on('value', callback);
    }

    saveActivePurchases(user, cart, purchase, purchaseId) {
        return new Promise((resolve, reject) => {
            this.getActivePurchases(user).then(snapshot => {
                let activePurchases = snapshot.val() || {};

                cart.forEach(cartItem => {
                    let activePurchase = {
                        purchaseDate: purchase.purchaseDate,
                        credits: cartItem.resource.pricing[cartItem.selectedOption].credits,
                        purchaseId: purchaseId,
                        locations: cartItem.locations || null
                    };
                    if (activePurchases[cartItem.resource.id]) {
                        activePurchases[cartItem.resource.id].push(activePurchase);
                    } else {
                        activePurchases[cartItem.resource.id] = [activePurchase];
                    }
                });

                this.firebase.database().ref(`/active_purchases/${user.orgId}`).set(activePurchases).then(snapshot => {
                    resolve(activePurchases);
                }, err => {
                    reject(err);
                });
            }).catch(err => {
                reject(err);
            });
        });
    }

    savePurchase(total, customer, user, cart) {
        return this.firebase.database().ref(`/purchase_history/${user.orgId}`).push({
            amount: total,
            customer: customer.id,
            user: user,
            purchaseDate: ZonedDateTime.now().withFixedOffsetZone().toString(),
            cart: cart
        }).then(snapshot => {
            return this.firebase.database().ref(`/purchase_history/${user.orgId}/${snapshot.key}`);
        });
    }

    createAdminResourceNotifyEvent(resource) {
        return this.firebase.database().ref('admin_resource_notify_events').push({
            date: ZonedDateTime.now().withFixedOffsetZone().toString(),
            resource: resource
        });
    }

    fetchSubscriptions(user) {
        var subscriptions = [];
        return this.firebase.database().ref(`/subscriptions/${user.orgId}`).once('value').then(snapshot => {
            snapshot.forEach(childSnapshot => {
                var subscription = childSnapshot.val();
                subscription.key = childSnapshot.key;
                subscriptions.push(subscription);
            });
            return subscriptions;
        });
    }

    removeSubscription(user, purchase, cartIndex) {
        return this.firebase.database().ref(`/purchase_history/${user.orgId}/${purchase.key}/cart/${cartIndex}/stripe_subscription`).remove();
    }

    fetchPurchaseHistory(user) {
        var history = [];
        return this.firebase.database().ref(`/purchase_history/${user.orgId}`).orderByChild('purchaseDate').once('value').then(snapshot => {
            snapshot.forEach(childSnapshot => {
                var historyItem = childSnapshot.val();
                historyItem.key = childSnapshot.key;
                history.unshift(historyItem);
            });
            return history;
        });
    }

    fetchSpecialties() {
        return this.firebase.database().ref(`/attributes/${attributeIds.practiceSpecialty}`).once('value');
    }

    fetchMedicationsAvailable() {
        return this.firebase.database().ref(`/attributes/${attributeIds.medicationsAvailable}`).once('value');
    }

    fetchAdminReport(startDate, endDate, specialtyId = null, medicationId = null) {
        return this.firebase.functions().httpsCallable("adminReportQuery")({startDate, endDate,specialtyId, medicationId});
    }

    // getBulkUploadLocations(bulkUploadId, success) {
    //     var ref = this.firebase.database().ref("locations");
    //     ref.orderByChild('bulkUploadId').startAt(bulkUploadId).endAt(bulkUploadId).once("value", function (snapshot) {
    //         var results = [];
    //         snapshot.forEach((node) => {
    //             var val = node.val();
    //             val.key = node.key //KBM - Need this for attributes
    //             results.push(val);
    //         });
    //         success(results);
    //     });
    // }
    //
    // removeLocation(location) {
    //     this.firebase.database().ref("locations/" + location.key).remove();
    // }
    //
    // deleteFromGeoFire(key) {
    //     this.geoFire.remove(key)
    // }

}
var apiInstance;
if (!apiInstance) {
    apiInstance = new Api();
}

export default apiInstance;



// WEBPACK FOOTER //
// ./src/api/api.js